import { Link } from "react-router-dom";
import { Helmet } from "@dr.pogodin/react-helmet";

export default function Certificate() {

    const allItems = [
        {
            img: "iso-certificate-2015.webp",
            pdf: "iso-certificate-2015.pdf",
            title: "Quality Management System"
        },
        {
            img: "iso-certificate-2022.webp",
            pdf: "iso-certificate-2022.pdf",
            title: "Information Security Management System"
        }
    ];
  const reversedImages = [...allItems].reverse();

  return (
    <>
      <Helmet>
        <title>Certificates</title>
        <meta name="description" content="" />
        <meta name="keywords" content="" />
        <meta property="og:url" content={`${import.meta.env.VITE_FRONTEND_URL}/certificates`} />
        <link rel="canonical" href={`${import.meta.env.VITE_FRONTEND_WWW_URL}/certificates`} />
        <meta property="og:title" content="Certificates" />
        <meta property="og:description" content="Infinitive Host is backed by reliable certifications, guaranteeing highly secure and trustworthy web hosting solutions. " />
      </Helmet>

      <div className="banner-bg pt-pb-100-banner bg-dark">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xxl-8 col-xl-8">
              <div className="text-center">
                  <span className="fs-18 fw-bold text-primary mb-2 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">ISO Verified</span>
                  <h1 className="text-white mb-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    Certificates
                    </h1>
                  <p className="text-white mb-8 max-text-60 mx-auto text-opacity-75 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    Infinitive Host is supported by industry-recognized certifications, ensuring the delivery of secure, reliable, and trustworthy IT and software solutions.
                  </p>
              </div>
            </div>
          </div>
        </div>
      </div>

        <section className="pt-100 pb-100">
          <div className="container">
            <div className="row certificate-row">
              {reversedImages.map((image) => (
                <div key={image.pdf} className="col-xl-4 col-lg-4 col-md-6">
                    <a className="img-card" href={`images/certificates/${image.pdf}`} target="_blank">
                        <figure className="img-frame">
                            <img src={`/images/certificates/${image.img}`} alt={image.title} title={image.title} />
                        </figure>
                        <h6 className="certificate-title text-center">{image.title}</h6>
                    </a>
                </div>
              ))}

            </div>
          </div>
        </section>
    </>
  );
}
